import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput", "contactItems", "sidebar", "chatArea", "closeSidebar", "showSidebar"]

  connect() {
    this.setupEventListeners()

    // Esperar a que el DOM esté completamente cargado antes de hacer scroll
    setTimeout(() => {
      this.scrollToSelectedChatroom()
      this.autoShowChatOnMobile()
    }, 100)

  }

  scrollToSelectedChatroom() {
    // Buscar el chatroom seleccionado en la sidebar
    const selectedChatroom = document.querySelector('.contact-item.bg-primary')
    if (selectedChatroom) {
      // Hacer scroll suave al chatroom seleccionado
      selectedChatroom.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }
  }

  disconnect() {
    // Don't remove chat-selected on disconnect - Turbo Stream replacements
    // cause disconnect/reconnect cycles which would flash the sidebar.
    // The class is only removed explicitly via showSidebar() or page navigation.
  }

  // Auto-show chat on mobile when a chatroom is already selected (initial page load)
  autoShowChatOnMobile() {
    if (window.innerWidth >= 768) return

    const selectedContact = document.querySelector('.contact-item.bg-primary')
    const chatMessages = document.querySelector('#messages')
    if (selectedContact && chatMessages && chatMessages.children.length > 0) {
      document.body.classList.add('chat-selected')
    }
  }

  setupEventListeners() {
    // Búsqueda de contactos
    if (this.hasSearchInputTarget) {
      this.searchInputTarget.addEventListener('input', this.handleSearch.bind(this))
    }

    // Cerrar sidebar en móvil
    if (this.hasCloseSidebarTarget) {
      this.closeSidebarTarget.addEventListener('click', this.closeSidebar.bind(this))
    }

    // Mostrar sidebar en móvil
    if (this.hasShowSidebarTarget) {
      this.showSidebarTarget.addEventListener('click', this.showSidebar.bind(this))
    }
  }

  handleSearch(event) {
    const searchTerm = event.target.value.toLowerCase()

    if (this.hasContactItemsTarget) {
      const items = this.contactItemsTarget.querySelectorAll('.contact-item')

      items.forEach(item => {
        const contactName = item.querySelector('h6')
        if (contactName) {
          const name = contactName.textContent.toLowerCase()
          if (name.includes(searchTerm)) {
            item.style.display = 'block'
          } else {
            item.style.display = 'none'
          }
        }
      })
    }
  }

  closeSidebar() {
    // On desktop, keep the sidebar visible alongside the chat.
    if (window.innerWidth < 768) {
      document.body.classList.add('chat-selected')
    }
  }

  showSidebar() {
    if (window.innerWidth < 768) {
      // On mobile, remove chat-selected class to show sidebar
      document.body.classList.remove('chat-selected')
    } else {
      // On desktop, show both
      if (this.hasSidebarTarget && this.hasChatAreaTarget) {
        this.sidebarTarget.style.display = ''
        this.chatAreaTarget.classList.remove('d-none')
        if (this.chatAreaTarget.classList.contains('col-12')) {
          this.chatAreaTarget.classList.remove('col-12')
          this.chatAreaTarget.classList.add('col-md-8', 'col-lg-9')
        }
      }
    }
  }
}
